export const getAuthHeaders = () => {
  let headers = {}
  let clientCredentials = window.localStorage.getItem("client_credentials")
  if (clientCredentials) {
    headers["Authorization"] = "Bearer " + clientCredentials
  }

  return headers
}



// WEBPACK FOOTER //
// ./src/constants/user.js